<section id="main" data-ng-controller="MaterialAdminCtrl as mactrl">
    <script type="text/ng-template" id="tlItemModalContent.html">
        <div class="modal-header">
            <h3 class="modal-title">Template details</h3>
        </div>
        <div class="modal-body">
            <p class="m-b-5">Template id: <b>{{tlItem.id}}</b></p>
            <p class="m-b-5">Account id: <b>{{tlItem.accountId}}</b></p>
            <p class="m-b-5" style="text-transform:capitalize">Template name: <b>{{tlItem.name}}</b></p>
        </div>
        <div class="modal-footer">
            <button type="input"class="btn btn-default app-btn-blue" ng-click="cancel()">Close</button>
        </div>
    </script>
    <div class="container">
        <div class="row main-row">
            <div class="side-column col-sm-4 p-0">
                <div class="wb-list-wrapper app-white-card m-b-15">
                    <a href="">
                        <div class="wb-list-item-lg">Quick payment or transfer<i class="zmdi zmdi-chevron-right pull-right"></i></div>
                    </a>
                    <div class="visible-xs">
                        <hr class="m-b-0 m-t-0 iban-style">
                        <a href="">
                            <div class="wb-list-item-lg">Pay template<i class="zmdi zmdi-chevron-right pull-right"></i></div>
                        </a>
                    </div>
                    <div class="hidden-xs">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-btn srch-icon" style="border:1px solid lightgray; border-right:none;">
                                    <button class="btn btn-default" type="submit" style="box-shadow:none;">
                                        <i class="glyphicon glyphicon-search"></i>
                                    </button>
                                </div>
                                <input data-ng-model="tmpSearchText.name" type="text" class="form-control srch-input" placeholder="Search templates" name="srch-term" id="srch-term">
                            </div>
                        </div>
                        <a data-ng-repeat="template in templateList.result | filter:tmpSearchText | limitTo : 5" href="">
                            <div ng-click="openTlItemModal(template, 'sm')" class="wb-list-item" style="text-transform:capitalize;" data-ng-class="{'wb-list-item-last':$last}">{{template.name}}<i class="zmdi zmdi-chevron-right pull-right"></i></div>
                        </a>
                    </div>
                </div>
                <div class="hidden-xs">
                    <div data-ng-include="'template/dashboard/instant-loan.tpl.html'"></div>
                    <div data-ng-include="'template/dashboard/contact-us.tpl.html'"></div>
                </div>

            </div>
            <div class="main-column col-sm-8 no-padding-on-phone">
                <div class="row">
                    <div class="col-sm-12 col-md-6 m-b-15">
                        <a href="">
                            <div class="debit-account-widget p-15 app-white-card">
                                <h4>Current account</h4>
                                <h2 class="no-bottom-margin">1.200,32 HRK</h2>
                                <p class="m-b-0">989,23 HRK available</p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-12 col-md-6 m-b-15">
                        <a href="">
                            <div class="savings-account-widget p-15 app-white-card">
                                <h4>Savings account</h4>
                                <h2 class="no-bottom-margin">1.200,32 RSD</h2>
                                <p class="m-b-0">989,23 RSD available</p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-12 col-md-6 m-b-15">
                        <a href="">
                            <div class="credit-master-account-widget p-15 app-white-card no-bottom-radius">
                                <h4>MasterCard Gold</h4>
                                <h2 class="no-bottom-margin">1.200,32 RSD</h2>
                                <p class="m-b-0">989,23 RSD available</p>
                            </div>
                        </a>
                        <uib-progressbar style="height:10px;" value="55"></uib-progressbar>
                    </div>
                    <div class="col-sm-12 col-md-6 m-b-15">
                        <a href="">
                            <div class="credit-visa-account-widget p-15 app-white-card no-bottom-radius">
                                <h4>Visa</h4>
                                <h2 class="no-bottom-margin">1.200,32 RSD</h2>
                                <p class="m-b-0">989,23 RSD available</p>
                            </div>
                        </a>
                        <uib-progressbar style="height:10px;" value="72"></uib-progressbar>
                    </div>
                    <div class="col-sm-12 hidden-xs" style="text-align:center;">
                        <button type="input"class="btn btn-default app-btn-blue-inverse show-all-accounts-btn">Show more accounts</button>
                    </div>

                </div>
                <h4 class="m-t-15 m-b-15 hidden-xs">Your bank timeline</h4>
                <div class="timeline-row com-sm-12">
                    <div class="hypo-timeline-wrapper app-white-card p-tbl-10-r-0">
                        <ul class="hypo-timeline">
                            <!-- timeline time label pending -->
                            <li class="time-label htl-item-pending">
                                <span class="bg-white htl-item-pending">Pending</span>
                            </li>
                            <!-- timeline item -->
                            <li>
                                <i class="zmdi zmdi-time-interval icon-pending"></i>
                                <div class="hypo-timeline-item htl-item-pending">
                                    <div class="hypo-timeline-body">
                                        <div class="col-md-6 col-sm-4 hypo-tlb-cell htlbc-desc">Monthly Salary</div>
                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-account-name">My Current Account</div>
                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-transaction-income">+ 700,00 HRK</div>
                                    </div>
                                </div>
                            </li>
                            <!-- timeline time label -->
                            <li class="time-label">
                                <span class="bg-white">Today</span>
                            </li>
                            <!-- timeline item -->
                            <li>
                                <i class="fa fa-income"></i>
                                <div class="hypo-timeline-item">
                                    <div class="hypo-timeline-body">
                                        <div class="col-md-6 col-sm-4 hypo-tlb-cell htlbc-desc">Monthly Salary</div>
                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-account-name">My Current Account</div>
                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-transaction-income">+ 700,00 HRK</div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <i class="fa fa-outcome"></i>
                                <div class="hypo-timeline-item">
                                    <div class="hypo-timeline-body">
                                        <div class="col-md-6 col-sm-4 hypo-tlb-cell htlbc-desc">Shop Payment</div>
                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-account-name">My Current Account</div>
                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-transaction-outcome">- 70,00 HRK</div>
                                    </div>
                                </div>
                            </li>
                            <!-- timeline time label -->
                            <li class="time-label">
                                <span class="bg-white">24. Feb</span>
                            </li>
                            <!-- timeline item -->
                            <li>
                                <i class="zmdi zmdi-forward item-online-payment"></i>
                                <div class="hypo-timeline-item">
                                    <div class="hypo-timeline-body">
                                        <div class="col-md-6 col-sm-4 hypo-tlb-cell htlbc-desc">Monthly Salary</div>
                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-account-name">My Current Account</div>
                                        <div class="col-md-3 col-sm-4 hypo-tlb-cell htlbc-transaction-income">+ 700,00 HRK</div>
                                    </div>
                                </div>
                            </li>
                            <li class="htl-login-item">
                                <span class=htl-login-label>
                                    <i class="zmdi zmdi-circle"></i>
                                    <span class="login-desc">Login at 19:23 from mobile device</span>
                                <span class="login-desc-light hidden-xs">  (iOS Safari, IP 193.123.234.21)</span>
                                </span>
                            </li>
                            <!-- timeline time label -->
                            <li class="time-label">
                                <span class="bg-white">23. Feb</span>
                            </li>
                            <!-- timeline item -->
                            <li>
                                <div class="hypo-timeline-item msg-item">
                                    <div class="bubble">
                                        <p class="msg-label no-bottom-margin">You received new e-invoice from Elektro Ljubljana d.o.o
                                            <span class="msg-action pull-right hidden-xs"><a href="">View it</a></span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="com-sm-12 visible-xs">
                    <div data-ng-include="'template/dashboard/instant-loan.tpl.html'"></div>
                    <div data-ng-include="'template/dashboard/contact-us.tpl.html'"></div>
                </div>

            </div>
        </div>
    </div>
</section>

<footer id="footer" data-ng-include="'template/footer.html'"></footer>
<!--<footer id="footer-hypo" data-ng-include="'template/footer-hypo.html'"></footer>-->
